import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialog } from '../dialogs/alert-dialog';
import { ConfirmDialog } from '../dialogs/confirm-dialog';
import { Referto } from '../models/referto';
import { ServiceRequest } from '../models/servicerequest';
import { BackendService } from '../services/backend.service';
import { ConfigService } from '../services/config.service';
import { MainService } from '../services/main.service';
import { UrlService } from '../services/url.service';

@Component({
  selector: 'app-document-search',
  templateUrl: './document-search.component.html',
  styleUrls: ['./document-search.component.css'],
  styles: [
    `
    .lis-icon {
      margin: 1rem;
      border: 5px solid transparent;
      cursor: pointer;
    }
    .icon-selected {
      border-radius: 50%;
      border: 5px solid #3f51b5;
    }`

  ]
})
export class DocumentSearchComponent implements OnInit {

  visualizzaRefertoSingolo: boolean = false;

  visualizzaRefertiList: boolean = false;

  passwordHide: boolean = true;

  usernameLabel: string = "USERNAME";

  pinLabel: string = "PIN";

  @ViewChild('reportContainer') reportContainer: ElementRef;

  @ViewChild('iframeReportContainer') iframeReportContainer: ElementRef;

  refForm: FormGroup;

  initialUsername: string = 'XXX';
  initialPin: string = '';

  scope: string;
  sede: string;

  referti: Referto[];
  selectedReferto: Referto;

  multi = false;

  gestioneGradimentoLIS = false;

  valueGradimentoLIS = null;

  gradimentoLISInviato = false;

  constructor(private fb: FormBuilder,
    private configService: ConfigService,
    private urlService: UrlService,
    private backendService: BackendService,
    private dialog: MatDialog,
    private mainService: MainService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    console.log('initializing DocumentSearchComponent');

    this.refForm = this.fb.group({
      username: [null, Validators.required],
      pin: [null, Validators.required]
    });

    this.configService.ensureConfig().subscribe(() => {

      this.backendService.getSessionId().subscribe(sid => {

        let initialScope = 'MMN';
        let initialSede = '01';
        if (this.configService.isDebug()) {
          this.refForm = this.fb.group({
            username: [this.configService.getDebugUsername(), Validators.required],
            pin: [this.configService.getDebugPin(), Validators.required]
          });
          initialScope = this.configService.getDebugScope();
          initialSede = this.configService.getDebugSede();
        }
        this.scope = this.urlService.getParam('scope', initialScope);
        this.sede = this.urlService.getParam('sede', initialSede);

        this.mainService.setScope(this.scope);
        this.mainService.setSede(this.sede);

        console.log(`scope = ${this.scope}`);
        console.log(`sede = ${this.sede}`);

        this.usernameLabel = this.configService.getUsernameLabel();
        this.pinLabel = this.configService.getPinLabel();

        if (this.urlService.getParam('inline') === 'true') {
          this.mainService.setInline(true);
        }
        if (this.urlService.getParam('multi') === 'true') {
          this.multi = true;
        }

        this.backendService.getEnvProperty(`app.frontend.gestioneGradimentoLIS.${this.sede}.initialValue`).subscribe(result => {
          if (!!result.value) {
            this.gestioneGradimentoLIS = JSON.parse(result.value);
          }
        });

      });

    });
  }

  onSubmit() {
    console.log(`submit completed`);
  }

  public onButtonClicked(form: HTMLFormElement) {

    this.visualizzaRefertoSingolo = false;
    this.visualizzaRefertiList = false;

    if (this.refForm.controls['username'].hasError('required') || this.refForm.controls['pin'].hasError('required')) {
      return;
    }

    let username: string = this.refForm.controls['username'].value;
    const pin: string = this.refForm.controls['pin'].value;
    username = username.toUpperCase();

    if (this.scope.toUpperCase() === 'MMN') {
      this.backendService.verificatRefertoMMN(username, pin).subscribe((res: boolean) => {
        if (res) {
          this.visualizzaRefertoSingolo = true;
        } else {
          this.dialog.open(AlertDialog, {
            data: { message: `Referto non trovato` }
          });
        }
      });
    } else {
      const request: ServiceRequest = {};
      request.codSede = this.sede;
      request.scope = this.scope;
      request.username = this.refForm.controls['username'].value;
      request.pin = this.refForm.controls['pin'].value;
      this.backendService.findReferti(request).subscribe((referti: Referto[]) => {
        console.log(`Received length = ${referti.length}`);
        console.log(`Received ${JSON.stringify(referti)}`);
        this.referti = referti;
        if (this.scope === 'BDOCS' && referti.length > 0) {
          this.selectedReferto = referti[0];
          if (this.selectedReferto.bdocsDocumentUrl != null) {
            this.mainService.createReportObjectBdocs(this.selectedReferto, this.reportContainer.nativeElement);
          }
        } else if (this.scope === 'LIS' && referti.length > 0) {
          if (referti.length === 1 && !this.multi) {
            this.selectedReferto = referti[0];
            this.mainService.setReferti(referti);
            this.mainService.setCodPaziente(referti[0].codPaziente);
            this.mainService.createReportObject(this.selectedReferto, this.mainService.isInline() ? this.iframeReportContainer.nativeElement : null);

            this.backendService.getEnvProperty(`app.frontend.gestioneGradimentoLIS.${this.sede}`).subscribe(result => {
              if (result.value === 'true') {
                this.gestioneGradimentoLIS = true;
              }
            });

          } else {
            this.mainService.setReferti(referti);
            this.mainService.setCodPaziente(referti[0].codPaziente);
            this.visualizzaRefertiList = true;
          }
        } else if (this.scope === 'RIS' && referti.length > 0) {
          this.mainService.setReferti(referti);
          this.mainService.setCodPaziente(referti[0].codPaziente);
          this.visualizzaRefertiList = true;
        } else if (this.scope === 'SPE' && referti.length > 0) {
          this.mainService.setReferti(referti);
          this.mainService.setCodPaziente(referti[0].codPaziente);
          this.visualizzaRefertiList = true;
        }
      });
    }

  }

  public mostraRefertoSingolo() {
    let username: string = this.refForm.controls['username'].value;
    const pin: string = this.refForm.controls['pin'].value;
    username = username.toUpperCase();
    if (this.scope.toUpperCase() === 'MMN') {
      let url = this.configService.getBackendUrl(`/refertoMMN?username=${username}&pin=${pin}`);
      window.open(url, '_blank');
    }
  }

  public cancellaRefertoSingolo() {
    let username: string = this.refForm.controls['username'].value;
    const pin: string = this.refForm.controls['pin'].value;
    username = username.toUpperCase();
    let dialogRef = this.dialog.open(ConfirmDialog, {
      data: { message: `Confermi la cancellazione del referto?` }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log(`dialog close with CONFERMA`);
        if (this.scope.toUpperCase() === 'MMN') {
          this.backendService.cancellaRefertoMMN(username, pin).subscribe((res: boolean) => {
            if (res) {
              this.visualizzaRefertoSingolo = false;
              this.dialog.open(AlertDialog, {
                data: { message: `Referto cancellato` }
              });
            }
          });
        }
      }
    });
  }

  public isLoading() {
    return this.mainService.getLoading();
  }

  onGradLisIconSelected($event) {
    const elems: HTMLCollectionOf<Element> = document.getElementsByClassName('icon-selected');
    for (let it = 0; it < elems.length; it++) {
      const elem = elems.item(it);
      this.renderer.removeClass(elem, 'icon-selected');
    }
    const eventElem: Element = $event.target;
    this.renderer.addClass(eventElem, 'icon-selected');
    this.valueGradimentoLIS = eventElem.id.replace('grad-', '');
  }

  onGradLisSendButton() {
    if (!!this.valueGradimentoLIS) {
      this.backendService.insertLogGradimento({ codSede: this.sede, valoreRilevato: this.valueGradimentoLIS }).subscribe(() => {
        this.gradimentoLISInviato = true;
      });
    }
  }

}
